import React, {Fragment, useEffect, useState} from 'react'
import  Sidebar from '../../components/Staff/Sidebar';
import TopBar from '../../components/Staff/TopBar';
import MetaData from '../../layouts/MetaData';
import Loader from '../../layouts/Loader';
import { useSelector, useDispatch } from 'react-redux';
import folderImg from '../../assets/Images/folder.png';
import { getDoctorPatients, patientActivate, patientDeActivate } from '../../actions/adminActions';
import IncludeDeactivatedToggle from '../../components/IncludeDeactivatedToggle';
import { Link, useHistory } from 'react-router-dom';
import { Badge, DropdownButton, Dropdown } from 'react-bootstrap';
import moment from 'moment';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import DeactivatePatientModal from '../../components/DeactivatePatientModal';
import { isDeceasedPatient } from '../../utils/deactivationReasons';
import { formatDate, formatDob } from '../../utils/dateFormat';

export const PATIENT_LIST_SORT_COLUMNS = {
    emrId: { type: 'string', value: (p) => p?.emrId },
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (p) => p?.DOB },
    status: { type: 'boolean', value: (p) => p?.block },
    provider: { type: 'name', value: (p) => personName(p?.assigned_doctor_id) },
    consent: { type: 'string', value: (p) => p?.patientType },
};


const StaffPatients = () => {
    let compliantStatus;

    const history = useHistory();
    
    const dispatch = useDispatch();
    
    const { user} = useSelector(state => state.auth);
    const { loading, doctorpatients } = useSelector(state => state.docPatients);
    const tableSort = useSortableTable(doctorpatients, { id: 'provider.rpmPatients', columns: PATIENT_LIST_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    
    let id = user._id;
    const [includeDeactivated, setIncludeDeactivated] = useState(false);

    useEffect(() => {
        dispatch(getDoctorPatients(id, includeDeactivated));
	}, [dispatch, includeDeactivated])

    const [deactivateTarget, setDeactivateTarget] = useState(null);
    // Deactivation goes through DeactivatePatientModal (required reason); its confirm re-enters with the reason.
    const toggleStatus = async (patient, deactivation) => {
        const deactivate = patient?.block !== true;
        if (deactivate && !deactivation) { setDeactivateTarget(patient); return; }
        if (!deactivate && isDeceasedPatient(patient)) { window.alert('This patient is marked deceased. Only a Super Admin can reactivate (Inactive Patients list).'); return; }
        if(deactivation || window.confirm((deactivate ? 'Deactivate ' : 'Reactivate ') + (patient?.lastname||'') + ', ' + (patient?.firstname||'') + '?')){
            await dispatch(deactivate ? patientDeActivate(patient._id, deactivation) : patientActivate(patient._id));
            dispatch(getDoctorPatients(id, includeDeactivated));
        }
    }

    function calculateCompliancyStatus(date) {  
        var m = moment(date);
        var today = moment().startOf('day');
        var days = moment.duration(today - m).asDays();

        switch(true){
            case (days >= 0 && days < 3):
                compliantStatus = 'compliant'
                break;

            case (days >= 3 && days <= 7):
                compliantStatus = "mostLikelyCompliant"
                break;

            case (days >= 8 && days <= 20):
                compliantStatus = "notLikelyCompliant"
                break;

            case (days >= 8 && days <= 31):
                compliantStatus = "nonCompliant"
                break;
            
            default:
                compliantStatus = 'nonCompliant'
                break;
        }
    }

    return (
        <Fragment>
           <MetaData title="My Patients"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                {loading ? <Loader /> : <Fragment>
                    <div className="shadow-lg p-3 mb-5 mr-4 ml-4 bg-white rounded">        
                        <div className="home-content">
                            <div>
                                <div className="row-display">
                                        <h5 className="title">RPM Patients 
                                            <p style={{color: '#004aad'}}>
                                                <small> Total RPM patients are: {doctorpatients && doctorpatients?.length < 10 ? '0'+doctorpatients?.length : doctorpatients?.length} </small> 
                                            </p>
                                        </h5>
                                    
                                    <div>
                                        <button 
                                        onClick={() => history.goBack()}
                                        className="btn btn-secondary btn-sm">
                                          <i className="bx bx-arrow-back"></i>  
                                        </button>
                                        &nbsp;&nbsp;
                                        <Link to="/doctor/Addpatient" className="btn btn-outline-primary btn-sm mt-4 mb-3">Enroll New Patient</Link>
                                        <IncludeDeactivatedToggle checked={includeDeactivated} onChange={setIncludeDeactivated} />
                                    </div>
                                </div>
                                
                                {doctorpatients?.length > 0 ? (<Fragment>
                                <div className="col-md-12">
                                    <Fragment>
                                        <table className="table table-sm table-striped">
                                        <thead align="center">
                                        <tr>  
                                            <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                            <SortableTh sortKey="dob" sort={tableSort}>DOB</SortableTh>
                                            <SortableTh sortKey="status" sort={tableSort}>Acc Status</SortableTh>
                                            <SortableTh sortKey="provider" sort={tableSort}>Physician</SortableTh>
                                            <th>Compliancy Status</th>
                                            <th>Last Reading </th>
                                            <SortableTh sortKey="consent" sort={tableSort}>Consent Program</SortableTh>
                                            <th>Actions</th> 
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tableSort.rows.map((patient, index) => ( 
                                            <tr align="center" key={index}>
                                            <td><Link className="link" to={{ pathname: "/doctor/patient/profile", state: {patientid: patient?._id, deviceid: patient?.deviceassigned?.deviceid}}}>{patient?.firstname} {patient?.lastname} <p>{patient?.phone1}</p></Link></td>
                                            
                                            <td> {formatDob(patient?.DOB)} <p><Badge bg="success text-white">{patient?.gender}</Badge></p></td>
                                            
                                            
                                            {patient?.block === false ? <td>
                                                <Badge pill bg="success text-white" style={{fontSize: '12px', fontWeight: 300}}>Active</Badge>
                                                </td> : <td><Badge pill bg="danger text-white" style={{fontSize: '12px'}}>Inactive</Badge>
                                            </td>}

                                            {patient?.assigned_doctor_id ? <>
                                                <td className="text-nowrap" style={{fontWeight: 'bold', color: '#23408e'}}>{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                                </> : <>
                                                <td><Badge pill bg="danger text-white" style={{fontSize: '12px'}}>Not Assigned</Badge></td>
                                            </>}
                                            
                                            {calculateCompliancyStatus(moment(patient?.lastReading))}    
                            
                                            <td>
                                                {patient?.lastReading ? 
                                                    compliantStatus === 'compliant' ? <p style={{color: 'green', fontWeight: 'bold'}}>
                                                        Compliant</p> : compliantStatus === 'mostLikelyCompliant' ? <p style={{color: '#F95800', fontWeight: 'bold'}}>
                                                            Most Likely Compliant</p> : compliantStatus === 'notLikelyCompliant' ? <p style={{color: 'dodgerblue', fontWeight: 'bold'}}>
                                                                Not Likely Compliant</p> : compliantStatus === 'nonCompliant' ? <p style={{color: 'red', fontWeight: 'bold'}}>
                                                                Non Compliant</p> : null : '--'}
                                            </td>

                                            <td>
                                                <span style={{fontWeight: 'bold'}}>{patient?.lastReading ? formatDate(patient?.lastReading) : '--'}</span>
                                            </td>
                                            
                                            <td>{patient?.patientType}</td>

                                            <td>
                                                <DropdownButton id="dropdown-basic-button" variant="Light">
                                                    <Dropdown.Item>
                                                        <Link className="link" to={{ pathname: "/doctor/patient/profile", state: {patientid: patient?._id}}}>View Profile</Link>
                                                    </Dropdown.Item>
                                                    {patient?.block === true
                                                        ? <Dropdown.Item onClick={() => toggleStatus(patient)}>Reactivate patient</Dropdown.Item>
                                                        : <Dropdown.Item onClick={() => toggleStatus(patient)}>Deactivate patient</Dropdown.Item>}
                                                </DropdownButton>
                                            </td>
                                        </tr> 
                                        
                                        ))}
                                        
                                        </tbody>
                                        </table>    
                                    </Fragment>                      
                            </div>
                        </Fragment> ) : <Fragment>

                        <div>   
                                <img src={folderImg} className="no-record-found-img"/>
                                <p className="doctor-specilizations">No Patient Assigned Yet...</p>         
                        </div>
                        </Fragment> }
                                <hr />
                            </div>
                        </div>
                    </div>
                         </Fragment> } 
                    <DeactivatePatientModal
                show={!!deactivateTarget}
                patient={deactivateTarget}
                onCancel={() => setDeactivateTarget(null)}
                onConfirm={(deactivation) => { const p = deactivateTarget; setDeactivateTarget(null); toggleStatus(p, deactivation); }}
            />
            </section>     
        </Fragment>
    )
}

export default StaffPatients
